var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.state !== -1)?_c('div',{staticClass:"wrapper",style:(_vm.loadVstyle),on:{"click":_vm.clickWrap}},[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.getText()))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }